const state = {
    avatar: []
}

const mutations = {
    SET_AVATAR(state, avatar) {
        state.avatar = avatar;
    },
    SET_B64_LOGO (state, logo) {
        state.avatar.logo = logo;
    }
}

const actions = {
    GET_AVATAR({commit}, avatar) {
        commit('SET_AVATAR', avatar);
    }
}

const getters = {
    avatar: state => {
        return state.avatar
    }
}

export default {namespaced: true, state, mutations, actions, getters}
